<template>
    <div class="container mainContent">
      <div>
        <form>
          <div class="form-group">
            <div>
              <h2 class="mb-4">Staff Dashboard</h2>
                <!-- <h4>พบกันเร็วๆนี้</h4> -->
            </div>
            <div>
              <div class="row">
                <div class="col-12 text-left mb-0">
                  <h4 class="mb-3">ข้อมูลกิจกรรม</h4>
                  <a class="btn btn-primary mb-2" @click="showDetail = false">ดูกิจกรรมทั้งหมด</a>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-lg-10 col-12">
                  <select required v-model="select_faculty" class="custom-select">
                    <option disabled selected value="-1">-- เลือกคณะ --</option>
                    <option value="CEN">กิจกรรมเวทีกลาง</option>
                    <option value="EN">คณะวิศวกรรมศาสตร์</option>
                    <option value="ARCH">คณะสถาปัตยกรรมศาสตร์</option>
                    <option value="IETECH">คณะครุศาสตร์อุตสาหกรรม</option>
                    <option value="AGRO">คณะอุตสาหกรรมการเกษตร</option>
                    <option value="IT">คณะเทคโนโลยีสารสนเทศ</option>
                    <option value="LA">คณะศิลปศาสตร์</option>
                    <option value="NANO">วิทยาลัยนาโนเทคโนโลยี</option>
                    <option value="AMI">วิทยาลัยนวัตกรรมการผลิตขั้นสูง</option>
                    <option value="MUSIC">วิทยาลัยวิศวกรรมสังคีต</option>
                    <option value="AEC">วิทยาลัยอุตสาหกรรมการบินนานาชาติ</option>
                    <option value="CHUMPHON">วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร</option>
                  </select>
                </div>
                <div class="col-lg-2 col-12 text-left">
                  <a class="btn btn-primary mb-2 w-100" @click="submit_faculty" :disabled="this.select_faculty == -1">ค้นหา</a>
                </div>
              </div> -->
              <div class="row mb-2" v-if="showDetail === false">
                <div class="col-12 text-left">
                  <h4>Staff : {{facultyTh}}</h4>
                  <a class="btn btn-primary" @click="scanWalking">สเเกนคนเข้าร่วมงาน</a>
                </div>
              </div>
              <div class="table-responsive" v-if="showDetail === false">
                <table class="table table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">วันที่</th>
                      <th scope="col">กิจกรรม</th>
                      <th scope="col">สถานที่</th>
                      <th scope="col">เวลา</th>
                      <th scope="col">จำนวนที่รับ</th>
                      <!-- <th class="description" scope="col">รายละเอียด</th> -->
                      <th scope="col">รายละเอียด</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr v-for="value in table_Compronent_23" v-bind:key="value.id">
                          <td scope="col"> {{ value.date + " สิงหาคม 2562"}} </td>
                          <td scope="col"> {{ value.name }} </td>
                          <td scope="col"> {{ value.place }} </td>
                          <td scope="col"> {{ value.time }} </td>
                          <td scope="col" v-if="value.maxAmount == 'unlimited'"> ไม่จำกัดจำนวน </td>
                          <td scope="col" v-if="value.maxAmount != 'unlimited'"> {{value.currentAmount}}/{{value.maxAmount}} </td>
                          <!-- <td class="description" scope="col"> {{ value.description }} </td> -->
                          <td><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)">ดูรายละเอียด</a></td>
                      </tr>
                      <tr v-for="value in table_Compronent_24" v-bind:key="value.id">
                          <td scope="col"> {{ value.date + " สิงหาคม 2562"}} </td>
                          <td scope="col"> {{ value.name }} </td>
                          <td scope="col"> {{ value.place }} </td>
                          <td scope="col"> {{ value.time }} </td>
                          <td scope="col" v-if="value.maxAmount == 'unlimited'"> ไม่จำกัดจำนวน </td>
                          <td scope="col" v-if="value.maxAmount != 'unlimited'"> {{value.currentAmount}}/{{value.maxAmount}} </td>
                          <!-- <td class="description" scope="col"> {{ value.description }} </td> -->
                          <td><a class="btn btn-primary" @click="onSure(value.id, value.name, value.date, value.time, value.place, value.maxAmount)">ดูรายละเอียด</a></td>
                      </tr>
                  </tbody>
                </table>
              </div>
              <div class="row" v-if="(table_Compronent_23 == null || table_Compronent_24 == null) && showDetail === false">
                <div class="col-12 text-center">
                  <h4>{{facultyTh}} ไม่มีกิจกรรมประเภทลงทะเบียนล่วงหน้า หรือ ไม่ได้ใช้ระบบของทางส่วนกลาง เเต่ยังสามารถสเเกนคนเข้าร่วมงานได้</h4>
                </div>
              </div>

              <div class="row" v-if="showDetail === true">
                <div class="col-12">
                  <div class="row mt-3 mb-3">
                    <div class="col-lg-6 text-left">
                      <h4>{{facultyTh}}</h4>
                      <h4>{{selectEventName}}</h4>
                      <h5>{{selectEventDate + " สิงหาคม 2562"}}</h5>
                      <h5>{{selectEventTime}}</h5>
                    </div>
                    <div class="col-lg-6 text-left">
                      <h5>ลงทะเบียนล่วงหน้า: {{ table_Compronent_registered.length + table_Compronent_attend.length }} คน</h5>
                      <h5>{{"เช็กอินเเล้ว: "+ table_Compronent_attend.length +" คน"}}</h5>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-12 text-left">
                  <a class="btn btn-primary mb-2 w-100" @click="toScan">แสกนเช็กอินเข้าร่วมกิจกรรม {{selectEventName}}</a>
                </div>

                <div class="col-12 mt-3">
                  <div class="table-responsive">
                    <div class="text-left">
                        <h4>รายชื่อผู้เช็กอินเเล้ว</h4>
                    </div>
                    <table class="table table-striped">
                      <thead class="thead-dark">
                          <tr>
                              <th scope="col">หมายเลขผู้ลงทะเบียน</th>
                              <th scope="col">ชื่อ</th>
                              <th scope="col">นามสกุล</th>
                              <th scope="col">โรงเรียน</th>
                              <th scope="col">เบอร์โทร</th>
                          </tr>
                      </thead>
                      <tbody v-if="table_Compronent_attend.length != 0">
                          <tr v-for="(value, index) in table_Compronent_attend">
                              <td scope="col"> ({{ index+1 }}) {{ value.id }} </td>
                              <td scope="col"> {{ value.name }} </td>
                              <td scope="col"> {{ value.surname }} </td>
                              <td scope="col"> {{ value.school }} </td>
                              <td scope="col"> {{ value.tel }} </td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="table_Compronent_attend.length == 0">
                    <div>
                      <h4>ยังไม่มีผู้ลงทะเบียนเช็กอิน</h4>
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-3">
                  <div class="table-responsive">
                    <div class="text-left">
                      <h4>รายชื่อผู้ลงทะเบียนล่วงหน้า</h4>
                    </div>
                    <table class="table table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col">หมายเลขผู้ลงทะเบียน</th>
                          <th scope="col">ชื่อ</th>
                          <th scope="col">นามสกุล</th>
                          <th scope="col">โรงเรียน</th>
                          <th scope="col">เบอร์โทร</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, index) in table_Compronent_registered">
                          <td scope="col"> ({{ index+1 }}) {{ value.id }} </td>
                          <td scope="col"> {{ value.name }} </td>
                          <td scope="col"> {{ value.surname }} </td>
                          <td scope="col"> {{ value.school }} </td>
                          <td scope="col"> {{ value.tel }} </td>
                        </tr>
                        <tr v-for="(value, index) in table_Compronent_attend">
                          <td scope="col"> ({{ index+1 }}) {{ value.id }} </td>
                          <td scope="col"> {{ value.name }} </td>
                          <td scope="col"> {{ value.surname }} </td>
                          <td scope="col"> {{ value.school }} </td>
                          <td scope="col"> {{ value.tel }} </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div v-if="showModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title req-field">{{ headModal }}</h5>
                    <button  class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true" @click="showModal = false">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p v-if="!isScan">{{ modalmsg }}</p>
                    <qrcode-stream @decode="onDecode" v-if="isScan"></qrcode-stream>
                    <div class="text-left" v-if="isScan">
                      <h5 class="mt-2"><span class="red">ผลการสเเกน:</span>  {{ decodeText }} </h5>
                      <!-- <h5 v-if="isScan" class="mb-0 mt-2">{{ scanMessage }}</h5> -->
                      <h5><span class="red">ผู้ลงทะเบียนที่สเเกนล่าสุด:</span> {{ lastScanUser }}</h5>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import { mapActions, mapGetters } from 'vuex';
import { QrcodeStream } from 'vue-qrcode-reader'
import axios from 'axios'

export default {
  name: "staffdashboard",
  components: {
    QrcodeStream
  },
  data: () => {
    return {
      date: "",
      decodeText: "กำลังรอสเเกน",
      lastScanUser: "ยังไม่ได้สเเกน",
      headModal: "",
      // scanMessage: "",
      isScan: false,
      select_faculty: -1,
      faculty_workshop: null,
      table_Compronent: null,
      table_Compronent_23: null,
      table_Compronent_24: null,
      table_Compronent_registered: [],
      table_Compronent_attend: [],
      selectEventEid: null,
      selectEventName: null,
      selectEventDate: null,
      selectEventTime: null,
      selectEventPlace: null,
      selectEventMaxAmount: null,
      key: null,
      submit: null,
      token: null,
      username: "Guest",
      showModal: false,
      modalmsg: "",
      showTable: false,
      facultyTh: null,
      showDetail: false,
      count: 0
    }
  },
  methods: {
    ...mapGetters([
      'getUsername'
    ]),
    submit_faculty() {
      if (this.select_faculty == "CEN") {
        this.facultyTh = "กิจกรรมเวทีกลาง"
      } else if (this.select_faculty == "EN") {
        this.facultyTh = "คณะวิศวกรรมศาสตร์"
      } else if (this.select_faculty == "IETECH") {
        this.facultyTh = "คณะครุศาสตร์อุตสาหกรรม"
      } else if (this.select_faculty == "AGRO") {
        this.facultyTh = "คณะอุตสาหกรรมการเกษตร"
      } else if (this.select_faculty == "AGRI") {
        this.facultyTh = "คณะเทคโนโลยีการเกษตร"
      } else if (this.select_faculty == "SCI") {
        this.facultyTh = "คณะวิทยาศาสตร์"
      } else if (this.select_faculty == "IT") {
        this.facultyTh = "คณะเทคโนโลยีสารสนเทศ"
      } else if (this.select_faculty == "FAM") {
        this.facultyTh = "คณะการบริหารและการจัดการ"
      } else if (this.select_faculty == "LA") {
        this.facultyTh = "คณะศิลปศาสตร์"
      } else if (this.select_faculty == "NANO") {
        this.facultyTh = "วิทยาลัยนาโนเทคโนโลยี"
      } else if (this.select_faculty == "AMI") {
        this.facultyTh = "วิทยาลัยนวัตกรรมการผลิตขั้นสูง"
      } else if (this.select_faculty == "MUSIC") {
        this.facultyTh = "วิทยาลัยวิศวกรรมสังคีต"
      } else if (this.select_faculty == "AEC") {
        this.facultyTh = "วิทยาลัยอุตสาหกรรมการบินนานาชาติ"
      } else if (this.select_faculty == "CHUMPHON") {
        this.facultyTh = "วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร"
      } else if (this.select_faculty == "MED") {
        this.facultyTh = "คณะแพทยศาสตร์"
      }
      this.headModal = "เเจ้งเตือน"
      this.showDetail = false
      this.showModal = true
      this.isScan = false
      this.modalmsg = 'กรุณารอซักครู่'
      if (this.select_faculty == -1) {
        this.headModal = "เเจ้งเตือน"
        this.showModal = true
        this.alertOnly = true
        this.isScan = false
        this.modalmsg = 'กรุณาเลือกคณะ'
        return false
      } else {
        axios.get(
          "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/getEventByFaculty",
          {
            headers: {
              "faculty": this.select_faculty
            }
          }
        )
        .then((res) => {
          this.showModal = false
          // console.log(res.data)
          // console.log(Object.keys(res.data).length);
          if (Object.keys(res.data).length != 0) {
            // var ordered = {};
            var ordered_23 = {};
            var ordered_24 = {};
            Object.keys(res.data).sort().forEach(function(key) {
              if (res.data[key].date == "23") {
                ordered_23[key] = res.data[key]
              } else {
                ordered_24[key] = res.data[key]
              }
            })
            // this.table_Compronent = ordered
            this.table_Compronent_23 = ordered_23
            this.table_Compronent_24 = ordered_24
          }
        })
        // .catch((err) => {
        //   console.log(err)
        // })
      }
    },
    onSure(eid, name, date, time, place, maxAmount) {
      this.showDetail = true
      this.showModal = true
      this.isScan = false
      this.headModal = "เเจ้งเตือน"
      this.modalmsg = 'กรุณารอซักครู่'
      this.selectEventEid = eid
      this.selectEventName = name
      this.selectEventDate = date
      this.selectEventTime = time
      this.selectEventPlace = place
      this.selectEventMaxAmount = maxAmount

      axios.get(
        "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/getEventByID",
        {
          headers: {
            "faculty": this.select_faculty,
            "id": this.selectEventEid
          }
        }
      )
      .then((res) => {
        this.table_Compronent_registered = res.data.registered
        this.table_Compronent_attend = res.data.attend
        this.showModal = false
        // console.log(res.data.registered)
        // console.log(res.data.attend)
      })
      // .catch((err) => {
      //   console.log(err)
      // })
    },
    toScan() {
      this.$router.push(`/staff/scan/?fac=${this.select_faculty}&eid=${this.selectEventEid}`)
    },
    scanWalking() {
      this.decodeText = "กำลังรอสเเกน"
      this.lastScanUser = "ยังไม่ได้สเเกน"
      this.headModal = "สเเกนคนเข้าร่วมงาน (" + this.facultyTh + ")"
      this.isScan = true
      this.showModal = true
    },
    onDecode(decodeString) {
      this.decodeText = "กำลังสเเกน"
      let regex = /(https:\/\/oph2019-kmitl-c2dac.)(firebaseapp.com|web.app)\/profile\?user=K([0-9]){5}&password=([A-Za-z0-9])+/g

      if (regex.test(decodeString)) {
        let params = decodeString.split('?')[1].split('&')
        let user = params[0].split('=')[1], pass = params[1].split('=')[1]
        this.lastScanUser = user
        // console.log(user, pass)
        axios({
          method: "POST",
          url: "https://us-central1-oph2019-kmitl-c2dac.cloudfunctions.net/event/walk-in",
          data: {
            id: user,
            faculty: this.select_faculty,
            day: this.date
          }
        })
        .then((res) => {
            console.log(res.data)
            if (res.data.status) {
              this.decodeText = "ผู้ลงทะเบียน " + user + " ได้เข้าร่วมงานเเล้วที่ " + this.facultyTh
            } else if (res.data.message === "You have already registered!") {
              this.decodeText = "ผู้ลงทะเบียน " + user + " เคยได้เข้าร่วมงานเเล้วที่ " + this.facultyTh
            }
        })
        .catch((err) => {
          console.log(err)
          this.decodeText = "กรุณาสเเกน QR code อีกรอบ"
        })
      } else {
        this.scanMessage = "กรุณาสเเกน QR code ที่ถูกต้อง"
      }
    }
  },
  mounted() {
    axios({
      method: "GET",
      url: "https://worldtimeapi.org/api/timezone/Asia/Bangkok",
    })
    .then((res) => {
      this.date = res.data.datetime.split("-")[2].slice(0,2)
      console.log("date: "+res.data.datetime.split("-")[2].slice(0,2))
    })
    // console.log(this.getUsername())
    if (this.getUsername() == "S00001") {
      this.select_faculty = "CEN"
      this.facultyTh = "กิจกรรมเวทีกลาง"
      this.submit_faculty()

    } else if (this.getUsername() == "S00002") {
      this.select_faculty = "EN"
      this.facultyTh = "คณะวิศวกรรมศาสตร์"
      this.submit_faculty()

    } else if (this.getUsername() == "S00003") {
      this.select_faculty = "ARCH"
      this.facultyTh = "คณะสถาปัตยกรรมศาสตร์"
      this.submit_faculty()

    } else if (this.getUsername() == "S00004") {
      this.select_faculty = "IETECH"
      this.facultyTh = "คณะครุศาสตร์อุตสาหกรรม"
      this.submit_faculty()

    } else if (this.getUsername() == "S00005") {
      this.select_faculty = "AGRO"
      this.facultyTh = "คณะอุตสาหกรรมการเกษตร"
      this.submit_faculty()

    } else if (this.getUsername() == "S00006") {
      this.select_faculty = "AGRI"
      this.facultyTh = "คณะเทคโนโลยีการเกษตร"
      this.submit_faculty()
    } else if (this.getUsername() == "S00007") {
      this.select_faculty = "SCI"
      this.facultyTh = "คณะวิทยาศาสตร์"
      this.submit_faculty()
    } else if (this.getUsername() == "S00008") {
      this.select_faculty = "IT"
      this.facultyTh = "คณะเทคโนโลยีสารสนเทศ"
      this.submit_faculty()
    } else if (this.getUsername() == "S00009") {
      this.select_faculty = "FAM"
      this.facultyTh = "คณะการบริหารและการจัดการ"
      this.submit_faculty()
    } else if (this.getUsername() == "S00010") {
      this.select_faculty = "LA"
      this.facultyTh = "คณะศิลปศาสตร์"
      this.submit_faculty()
    } else if (this.getUsername() == "S00011") {
      this.select_faculty = "NANO"
      this.facultyTh = "วิทยาลัยนาโนเทคโนโลยี"
      this.submit_faculty()
    } else if (this.getUsername() == "S00012") {
      this.select_faculty = "AMI"
      this.facultyTh = "วิทยาลัยนวัตกรรมการผลิตขั้นสูง"
      this.submit_faculty()
    } else if (this.getUsername() == "S00013") {
      this.select_faculty = "MUSIC"
      this.facultyTh = "วิทยาลัยวิศวกรรมสังคีต"
      this.submit_faculty()
    } else if (this.getUsername() == "S00014") {
      this.select_faculty = "AEC"
      this.facultyTh = "วิทยาลัยอุตสาหกรรมการบินนานาชาติ"
      this.submit_faculty()
    } else if (this.getUsername() == "S00015") {
      this.select_faculty = "CHUMPHON"
      this.facultyTh = "วิทยาเขตชุมพรอุดมศักดิ์ จังหวัดชุมพร"
      this.submit_faculty()
    } else if (this.getUsername() == "S00016") {
      this.select_faculty = "MED"
      this.facultyTh = "คณะแพทยศาสตร์"
      this.submit_faculty()
    } else if (this.getUsername() == "S00017") {
      this.select_faculty = "EDU"
      this.facultyTh = "วิทยาลัยวิจัยนวัตกรรมทางการศึกษา"
      this.submit_faculty()
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-title {
  color: #ee4b23;
}

select.custom-select {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  margin-bottom: 1em;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
}

td, th {
  text-align: justify;
}

th {
  text-align: justify;
}

.btn-primary {
  color: #fff;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {
  color: rgba(255,255,255,.5);
  text-decoration: none;
  background-color: #ee4b23;
  border-color: #ee4b23;
}

a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
}

.red {
  color:#ee4b23;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .9s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.mainContent {
  min-height: calc(100vh - 322px) ;
}

@media screen and (max-width: 568px) {
	.description {
    display: none;
  }
}
</style>
